<script setup lang="ts">
import { computed } from 'vue';
import { getCurrencyByCode } from '@/helpers/currencyHelper';

const props = defineProps<{
    code: string;
}>();
const currency = computed(() => getCurrencyByCode(props.code));
const isSymbol = computed(() => {
    if (!currency.value?.symbol) return false;
    const firstSymbol = currency.value.symbol.charAt(0);
    const firstCode = currency.value.code.charAt(0);
    return firstSymbol !== firstCode;
});

const isText = computed(() => !isSymbol.value);

const getCurrencyColor = (code: string) => {
    switch (code) {
        case 'USD':
            return 'var(--success)';
        case 'EUR':
            return 'var(--blue)';
        case 'GBP':
            return 'var(--red)';
        case 'JPY':
            return 'var(--yellow)';
        case 'CNY':
            return 'var(--flamingo)';
        case 'KGS':
            return 'var(--tertiary)';
        case 'RUB':
            return 'var(--red)';
        case 'INR':
            return 'var(--secondary)';
        default:
            return 'var(--primary)';
    }
};
</script>
<template>
    <span
        class="currency-symbol"
        :class="{
            'is-text': isText
        }"
        :style="{
            backgroundColor: getCurrencyColor(currency.code)
        }"
        >{{ currency.symbol }}</span
    >
</template>

<style lang="scss" scoped>
.currency-symbol {
    font-size: 11px;
    font-weight: 600;
    border-radius: 50%;
    background-color: var(--primary);
    color: var(--white);
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    &.is-text {
        font-size: 6px;
    }
}
</style>
